import { useAuthorization, ROLES } from 'lib/authorization';
import { HomeIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import * as React from 'react';
import { CiViewTimeline } from 'react-icons/ci';
import {
  FileText,
  Users,
  Film,
  BookOpen,
  Briefcase,
  MessageCircle,
  Box,
  Globe,
  HelpCircle,
  DollarSign,
  Archive,
  Settings,
  Monitor,
  Grid,
} from 'react-feather';
import { NavLink } from 'react-router-dom';
import { CogIcon, OfficeBuildingIcon } from '@heroicons/react/solid';
import { MdWeb } from 'react-icons/md';

export const SideNavigation = ({ showLabels = true }) => {
  const { checkAccess } = useAuthorization();
  const navigation = [
    { name: 'Overview', to: '.', icon: HomeIcon },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'Members',
      to: './members',
      icon: Users,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'Transactions',
      to: './transactions',
      icon: FileText,
    },
    checkAccess({ allowedRoles: [ROLES.SUPER_ADMIN] }) && {
      name: 'Moderators',
      to: './moderators',
      icon: Users,
      heading: 'Administration',
    },
    checkAccess({ allowedRoles: [ROLES.SUPER_ADMIN] }) && {
      name: 'Teams',
      to: './teams',
      icon: Users,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'Support & FAQs',
      to: './support',
      icon: HelpCircle,
    },

    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: '10K Project',
      to: './10k-project',
      icon: DollarSign,
      heading: 'Projects',
    },
    checkAccess({ allowedRoles: [ROLES.SUPER_ADMIN] }) && {
      name: 'Satellite City',
      to: './satellite-city',
      icon: OfficeBuildingIcon,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'Pearl Life',
      to: './pearl-life',
      icon: Globe,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'UAP Investment',
      to: './uap-investment',
      icon: Briefcase,
    },

    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'Settings',
      to: './settings',
      icon: CogIcon,
      heading: 'System',
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'WLU Website',
      to: './website',
      icon: MdWeb,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] }) && {
      name: 'Activity Log',
      to: './activity-log',
      icon: Box,
    },

    checkAccess({ allowedRoles: [ROLES.SUPER_ADMIN, ROLES.DEVELOPER] }) && {
      name: 'Applications',
      to: './applications',
      icon: Grid,
      heading: 'Integrations',
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DEVELOPER] }) && {
      name: 'Payment Providers',
      to: './payment-providers',
      icon: Box,
    },
    checkAccess({ allowedRoles: [ROLES.SUPER_ADMIN, ROLES.DEVELOPER] }) && {
      name: 'API Users & API Keys',
      to: './api-users-keys',
      icon: Box,
      heading: 'Developer',
    },
    checkAccess({ allowedRoles: [ROLES.SUPER_ADMIN, ROLES.DEVELOPER] }) && {
      name: 'Developer Settings',
      to: './integrations',
      icon: Box,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DEVELOPER] }) && {
      name: 'Security Log',
      to: './integrations',
      icon: Box,
    },
  ].filter(Boolean);

  return (
    <>
      {navigation.map((item, index) => (
        <div key={index}>
          {item.heading && (
            <p
              key={index}
              className="px-3 py-4 my-2 text-xs flex flex-row font-sm text-blue-300 uppercase tracking-wider"
            >
              <span>{showLabels && item.heading}</span>
            </p>
          )}
          <NavLink
            end={index === 0}
            key={item.name}
            to={item.to}
            className={clsx(
              'text-white  hover:font-black hover:text-red-500 hover:bg-gray-700',
              'group flex items-center px-2 py-2 text-sm font-md rounded-md mb-3'
            )}
          >
            <div className="flex flex-col">
              <div className="flex">
                <item.icon
                  className={clsx(
                    'text-white group-hover:text-red-500 hover:font-black',
                    'mr-4 flex-shrink-0 h-6 w-6'
                  )}
                  aria-hidden="true"
                />
                {showLabels && <span className="text-sm">{item.name}</span>}
              </div>
            </div>
          </NavLink>
        </div>
      ))}
    </>
  );
};
